import BeijingBankIcon from '@/assets/images/bankIcon/beijing.png';
import GongshangBankIcon from '@/assets/images/bankIcon/gongshang.png';
import GuangdaBankIcon from '@/assets/images/bankIcon/guangda.png';
import GuangfaBankIcon from '@/assets/images/bankIcon/guangfa.png';
import HuaxiaBankIcon from '@/assets/images/bankIcon/huaxia.png';
import JiansheBankIcon from '@/assets/images/bankIcon/jianshe.png';
import JiaotongBankIcon from '@/assets/images/bankIcon/jiaotong.png';
import MinshengBankIcon from '@/assets/images/bankIcon/minsheng.png';
import NongyeBankIcon from '@/assets/images/bankIcon/nongye.png';
import PinganBankIcon from '@/assets/images/bankIcon/pingan.png';
import PufaBankIcon from '@/assets/images/bankIcon/puda.png';
import ShanghaiBankIcon from '@/assets/images/bankIcon/shanghai.png';
import XingyeBankIcon from '@/assets/images/bankIcon/xingye.png';
import YouchuBankIcon from '@/assets/images/bankIcon/youchu.png';
import ZhaoshangBankIcon from '@/assets/images/bankIcon/zhaoshang.png';
import ZhongguoBankIcon from '@/assets/images/bankIcon/zhongguo.png';
import ZhongxinBankIcon from '@/assets/images/bankIcon/zhongxin.png';

export default {
  ConvertLinkRecordType: {
    "0": "创建新链路",
    "1": "绑定渠道",
    "2": "解绑渠道",
    "3": "添加链路行为",
    "4": "修改行为配置",
    "5": "删除链路行为",
    "6": "启用链路",
    "7": "禁用链路",
    "8": "修改名称"
  },
  PostBackAction: { //行为枚举
    '20': '添加联系人',
    '25': '开口',
    "30": "48小时删除联系人",
    "26": "开口-腾讯二次回传"
  },
  //请求code枚举
  ResponseCode: {
    SUCCESS: 0,
    SKU_NOT_ON_SALE: 81040006, //"商品未上架"
    SKU_USER_MAX_LIMIT: 81040016, //"超出商品限购数量"
    SKU_USER_SERVICE_PERIOD_LIMIT: 81040017 //"超出商品限购服务期"
  },
  //优惠券枚举
  CouponUnailableReasonConstant: {
    REASON_USED: 1,                 //优惠券已使用
    REASON_NOT_START: 2,            //优惠券未开始
    REASON_EXPIRED: 3,              //优惠券已过期
    REASON_NOT_SUPPORT: 4,          //优惠券不支持该sku
    REASON_LESS_THEN_FULL_AMOUNT: 5 //优惠券未到满减金额
  },
  //支付方式
  PayType: {
    WX: '10-10',
    WXTONGLIAN : '10-20',
    WXLAKALA: '10-30',
    WXLIANLIAN: '10-40',
    WXNINGBO: '10-50',
    ALI: '20-10',
    ZFBLAKALA: '20-30',
    ZFBLIANLIAN: '20-40',
    ZFBNINGBO: '20-50',
    YINLIAN: '40-20',
    BULKPAY: '50-30',
    YINHANGKA: '60-20'
  },
  PayTypeString: {
    10: "微信原生",
    20: "支付宝",
    30: "银行卡",
    40: "银联支付",
    60: "通联微信支付",
    70: '拉卡拉微信支付'
  },
  QuickBindBankList: [
    { code: '01020000', name: '工商银行', icon: GongshangBankIcon },
    { code: '01030000', name: '农业银行', icon: NongyeBankIcon },
    { code: '01040000', name: '中国银行', icon: ZhongguoBankIcon },
    { code: '03010000', name: '交通银行', icon: JiaotongBankIcon },
    { code: '01050000', name: '建设银行', icon: JiansheBankIcon },
    { code: '01000000', name: '邮储银行', icon: YouchuBankIcon },
    { code: '03030000', name: '光大银行', icon: GuangdaBankIcon },
    { code: '03020000', name: '中信银行', icon: ZhongxinBankIcon },
    { code: '03050000', name: '民生银行', icon: MinshengBankIcon },
    { code: '03100000', name: '浦发银行', icon: PufaBankIcon },
    { code: '03060000', name: '广发银行', icon: GuangfaBankIcon },
    { code: '03090000', name: '兴业银行', icon: XingyeBankIcon },
    { code: '03040000', name: '华夏银行', icon: HuaxiaBankIcon },
    { code: '03080000', name: '招商银行', icon: ZhaoshangBankIcon },
    { code: '04105840', name: '平安银行', icon: PinganBankIcon },
    { code: '04012900', name: '上海银行', icon: ShanghaiBankIcon },
    { code: '04031000', name: '北京银行', icon: BeijingBankIcon }
  ],
  //支付登录端
  TradeType: {
    WEB: "WEB",
    JSAPI: "JSAPI"
  },
  LklAccountType: {
    JSAPI: 51, // 微信公众号支付，支付宝服务窗支付，银联JS支付，翼支付JS支付、拉卡拉钱包支付
    NATIVE: 41,// ALIPAY，云闪付支持
    MINI: 71, //微信小程序支付
  },
  OrderStatus: {
    PAID: 1, //已支付
    PAYING: 2, //待支付
    CLOSED: 3, //已关闭
    PASSED: 4, //已开通
    REFUND: 5, //已退款
    FREEZE: 6, //已冻结
  },
  OrderUnFinishedReason: {
    EXIST_UNPAID_ORDER: 1, //存在待支付的订单
    EXIST_UNSIGN_ORDER: 2, //存在待签字的订单
  },
  ProductLevelInfo: {
    10: '一档A',
    12: '一档B',
    13: '一档C',
    15: '二档',
    20: '三档',
    25: '四档',
    30: '优惠券',
    35: 'QMT智投',
    36: "财达智投",
    40: "投教一档",
    41: "投教二档",
    50:"旗舰版",
    51:'大师版'
  },
  SkuStatus: {
    WAIT_SALE: 1, // 待上架
    ON_SALE: 2,  //已上架
    OFF_SALE: 3,  //已下架
    PREHEAT_SALE: 4, //预热时间
  },
}
